import { AnalyticsRefDimension, CriteriaType } from '../../../../state'
import { DepthRefFieldMapper, DepthRefGetterCallback, RefFieldMapperType } from './interfaces'

// Simple interface for the has_active_ehr_site boolean field
interface HasActiveEhrSiteRef {
    hasActiveEhrSite: string
}

const getItemLabel: DepthRefGetterCallback<HasActiveEhrSiteRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return 'Has data from an active EHR site'
    }
}

const getItemValue: DepthRefGetterCallback<HasActiveEhrSiteRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return item.hasActiveEhrSite
    }
}

const getItemTooltip: DepthRefGetterCallback<HasActiveEhrSiteRef> = (item, depth) => {
    if (!item) {
        return undefined
    }
    switch (depth) {
        case 0:
            return getItemLabel(item, depth)
    }
}

export const HasActiveEhrSiteRefFieldMapper: DepthRefFieldMapper<HasActiveEhrSiteRef> = {
    type: RefFieldMapperType.Depth,
    dimension: AnalyticsRefDimension.SEX, // Reuse SEX dimension since it's the same patient table
    criteriaType: CriteriaType.PatientAttributes,
    table: 'patient',
    dateField: {
        first: 'null_date',
        last: 'null_date',
        any: 'null_date'
    },
    dateFieldInverse: {},
    searchPlaceholder: '',
    noResultsMessage: '',
    searchHintMessage: '',
    filterFieldToRefField: { has_active_ehr_site: 'hasActiveEhrSite' },
    filterFieldOrder: ['has_active_ehr_site'],
    filterLabelOrder: ['has_active_ehr_site'],
    getItemLabel,
    getItemValue,
    getItemTooltip
}
